export const DateDivider = () => (
  <div className="flex gap-2 items-center w-full">
    <div className="flex-1 h-px bg-gray-200" />
    <p className="text-sm font-medium leading-5 text-center text-gray-600">
      Today
    </p>
    <div className="flex-1 h-px bg-gray-200" />
  </div>
);
